import './blocks/slider/script';